import {
  UPDATECUSTOMERWALLETLIST_SUCCESS,
  UPDATECUSTOMERWALLETLIST_FAILED,
  RESET_UPDATECUSTOMERWALLETLIST,
  LOADING_UPDATECUSTOMERWALLETLIST,
  NETWORK_ERROR_UPDATECUSTOMERWALLETLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATECUSTOMERWALLETLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATECUSTOMERWALLETLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATECUSTOMERWALLETLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATECUSTOMERWALLETLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATECUSTOMERWALLETLIST:
      return (state = initialState);
    default:
      return state;
  }
};
